import { type TreeId } from '@fs/zion-tree-types'

/**
 * How many entries the change log is asked for.
 */
const CHANGE_LOG_PAGE_SIZE = 5

/**
 * The change log URL for a tree, shared by every caller so they land on one cached request per tree.
 *
 * Returns a URL for a missing tree id too, since `useZionAxios` wants a URL on every render. A caller
 * with no tree id is expected to hold the request back itself, the way `useLastTreeChange` does with
 * `manual`.
 */
export default function getTreeChangeLogUrl(treeId: TreeId | undefined | null): string {
  return `/service/tree/tree-data/user/all/tree/${treeId}/contributions?pageSize=${CHANGE_LOG_PAGE_SIZE}`
}
